exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaderboard-active input{border-width:1px}.interesante{width:100%;height:86vh;position:absolute}", ""]);

// exports
